import type { ReactNode } from 'react';
import Logo from './Logo';
import { cn } from '../../lib/utils';

interface ShellProps {
  children: ReactNode;
  centered?: boolean;
  maxWidth?: 'narrow' | 'default' | 'wide';
}

const widths = {
  narrow: 'max-w-md',
  default: 'max-w-2xl',
  wide: 'max-w-3xl',
};

export default function Shell({ children, centered = false, maxWidth = 'default' }: ShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="flex items-center justify-center border-b border-border/60 bg-card/60 px-4 py-4 backdrop-blur">
        <Logo className="h-12" />
      </header>
      <main
        className={cn(
          'flex flex-1 flex-col items-center px-4 pb-16',
          centered ? 'justify-center pt-6' : 'pt-8 sm:pt-12',
        )}
      >
        <div className={cn('w-full', widths[maxWidth])}>{children}</div>
      </main>
    </div>
  );
}
